import { Link } from '@mui/joy';

import { DEFAULT_PLACEHOLDER } from 'core/constants';

interface IProps {
  phone: string;
}

export const PhoneNumber = ({ phone }: IProps) => {
  if (!phone) {
    return <>{DEFAULT_PLACEHOLDER}</>;
  }

  let formattedPhone = phone.replace(/\D/g, '');

  const match = formattedPhone.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    formattedPhone = `${match[1]}-${match[2]}-${match[3]}`;
  }

  return <Link href={`tel:${formattedPhone}`}>{formattedPhone}</Link>;
};
